import { render, staticRenderFns } from "./Otp-form.vue?vue&type=template&id=23d85dec&scoped=true"
import script from "./Otp-form.vue?vue&type=script&lang=js"
export * from "./Otp-form.vue?vue&type=script&lang=js"
import style0 from "./Otp-form.vue?vue&type=style&index=0&id=23d85dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d85dec",
  null
  
)

export default component.exports